import { useQuery } from '@hooks/reactQuery';

import { getPortalProjectById } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';

import { IProjectDTO } from '@interfaces/portal/dto/projectManagementDTO';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_PROJECT } from '@constants/queryKeys';

interface IUseQueryPortalProjectReturned {
	isLoadingPortalProject: boolean;
	portalProject?: IProjectDTO;
}

export const useQueryPortalProject = (id: string): IUseQueryPortalProjectReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<IProjectDTO>({
			queryKey: [GET_PORTAL_PROJECT, { id }],
			queryFn: extractQueryParams(getPortalProjectById),
			...refetchOptions,
		},
	);

	return {
		isLoadingPortalProject: isLoading || isFetching,
		portalProject: data,
	};
};
